import { Icons } from '@/assets/icons/icons';
import { FEATURES } from '@/features/feature-flags';
import { setHashInElectron } from '@/hooks/useHashRoute';
import { isMac } from '@/utils/capabilities';
import { navigate } from '@/utils/navigation-service';

import { IntegrationsSpotlight } from './integrations-spotlight';
import { SpritesSpotlight } from './sprites-spotlight';
import { type WhatsNewFeature } from './whats-new.types';

export const WHATS_NEW_VERSION = 'v3';
export const WHATS_NEW_EXPIRES_AT = new Date('2026-12-31T00:00:00');

const spritesFeature: WhatsNewFeature = {
  title: 'Build anything.\nShare it with a click.',
  badge: 'Beta',
  requiresFeature: FEATURES.SPRITES,
  image: <SpritesSpotlight />,
  bullets: [
    {
      icon: <Icons.gridPlus className="size-4" />,
      text: 'Littlebird can build websites, PDFs and more.',
    },
    {
      icon: <Icons.sparkles className="size-4" />,
      text: "It already knows your world, so you're never starting from scratch.",
    },
    {
      icon: <Icons.share className="size-4" />,
      text: 'Tweak it, theme it, then share with the world.',
    },
  ],
  primaryCta: {
    label: 'Try Library',
    onClick: () => {
      navigate({ to: '/sprites' });
    },
  },
};

const integrationsFeature: WhatsNewFeature = {
  title: 'Connect everything.\nAsk anything.',
  // This is a carried-over slide from the previous (v2) integrations announcement. Gate it on the
  // same Sprites flag so the version bump doesn't re-show a stale integrations-only modal to users
  // outside the Sprites rollout — they should get no modal, not a repeat of what they dismissed.
  requiresFeature: FEATURES.SPRITES,
  image: <IntegrationsSpotlight />,
  bullets: [
    {
      icon: <Icons.gridPlus className="size-4" />,
      text: 'Connect the apps you actually work in — Gmail, Slack, Notion, GitHub, and 95 more.',
    },
    {
      icon: <Icons.messageSearch className="size-4" />,
      text: 'Ask Littlebird about your emails, meetings, files, and tasks — all in one place.',
    },
    {
      icon: <Icons.eyeOff className="size-4" />,
      text: 'Toggle access per chat. You decide what Littlebird can see, always.',
    },
  ],
  primaryCta: {
    label: 'Set up integrations',
    onClick: () => {
      setHashInElectron('settings/Integrations');
    },
  },
};

export const whatsNewContent: WhatsNewFeature[] = [
  spritesFeature,
  ...(isMac() ? [integrationsFeature] : []),
];
